/** @jsx jsx */

import React, {
  Fragment as _,
  memo,
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
} from 'react';
import { keyframes } from 'emotion';
import { css, jsx } from '@emotion/core';
import { values, colors } from 'styles/variables';
import getTopics from 'services/apiHelpers/getTopics';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import setCurrentTopic from 'services/apiHelpers/setCurrentTopic';
import { VisuallyHidden } from 'components/UI/VisuallyHidden';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import getTopicSId from 'services/getTopicSId';
import getSectionInView from 'services/getSectionInView';
import getCurrentLocation from 'services/getCurrentLocation';

const { lPink, lGrey0 } = colors;

const open_menu_kf = keyframes`
from {
	opacity: 0;
	transform: translateX(100%);
}
to {
	opacity: 1;
	transform: translateX(-10px);
}
`;

const close_menu_kf = keyframes`
0% {
	opacity: 1;
	transform: translateX(0%);
}
35% {
	opacity: 1;
	transform: translateX(-10%);
}
100% {
	opacity: 0;
	transform: translateX(100%);
}
`;

const Menu = ({ menu, currentTopicName, color = lGrey0, close }) => {
  const topics = getTopics();
  const init = useRef(false);
  const nav = useRef(null);
  const tabIndex = useRef(0);

  // console.log('init.current :', init.current);

  useEffect(() => {
    let addBurger = false;

    if (menu) {
      tabIndex.current = 0;
      // topics.findIndex(
      //   (t: any) => t.props.name === currentTopicName
      // );
      // console.log({ 'tabIndex.current': tabIndex.current });
      // topics.findIndex((t:any) => t.name === currentTopicName);
      window.addEventListener('keydown', keyOverrides);
    }

    function keyOverrides(e) {
      switch (e.key) {
        case 'Escape': {
          return close();
        }

        case 'Tab': {
          e.preventDefault();

          const burgerX = document.querySelector('#burger-x');
          const anchors: any = [
            ...(addBurger ? [burgerX] : []),
            ...Array.from(nav.current.querySelectorAll('a')),
          ];
          //.filter((t: any) => t.props.name !== currentTopicName);

          anchors[tabIndex.current].focus();

          // if (tabIndex.current < topics.length - 1) {
          if (tabIndex.current < anchors.length - 1) {
            tabIndex.current = tabIndex.current + 1;
          } else {
            if (!addBurger) {
              addBurger = true;
            }
            tabIndex.current = 0;
          }
        }
      }

      // if (e.key === 'Escape') {
      //   return alert('ESCAPE');
      // }

      // if (e.key === 'Tab') {
      //   e.preventDefault();

      //   const anchors: any = Array.from(nav.current.querySelectorAll('a'));

      //   anchors[tabIndex.current].focus();

      //   if (tabIndex.current < topics.length - 1) {
      //     tabIndex.current = tabIndex.current + 1;
      //   } else {
      //     tabIndex.current = 0;
      //   }
      // }
    }

    return () => {
      window.removeEventListener('keydown', keyOverrides);
    };
  }, [menu]);

  useEffect(() => {
    if (!nav.current) {
      return;
    }

    const onAnimationEnd = (e: any) => {
      const { target } = e;
      if (target == nav.current) {
        // why wouldn't it be ???
        if (!menu && init.current) {
          requestAnimationFrame(() => {
            // console.log(menu, init.current);
            nav.current.style.visibility = 'hidden';
          });
        }
      }
    };

    nav.current.addEventListener('animationend', onAnimationEnd);

    return () => {
      nav.current.removeEventListener('animationend', onAnimationEnd);
    };
  }, [menu]);

  useEffect(() => {
    if (menu && !init.current) init.current = true;
  }, [menu]);

  // useLayoutEffect(() => {
  //   // init.current = true;
  // }, []);

  return (
    <nav
      ref={nav}
      aria-hidden={!menu}
      aria-label="navigation"
      css={css`
					position: absolute;
					right: -30px;
					top: 10px;
					min-width: 300px;
					padding: 65px 30px 20px 20px;
					background: #fff;
					${!menu &&
            !init.current &&
            `
          visibility: hidden;`}

					animation: ${menu ? open_menu_kf : close_menu_kf} 0.3s forwards;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

          @media (max-width: 480px) {
            width: calc(100vw - 20px);
            padding: 50px 20px 20px 15px;
          }

        `}
      style={{
        ...(menu &&
          init.current && {
            visibility: 'visible',
          }),
      }}
    >
      <ul>
        {topics.map(t => {
          const { id } = t;
          const { name } = t.props;
          return (
            <li
              key={id}
              css={css`
                margin: 5px 0;
                text-align: right;
                cursor: pointer;
                list-style: none;
                // color: ${color} !important;
                font-weight: ${name === currentTopicName ? 700 : 'normal'};
                line-height: ${1.2 * 1.5}em;
                pointer-events: ${name === currentTopicName ? 'none' : 'auto'};

                a {
                  color: ${color} !important;

                  &:hover {
                    color: #767676 !important;
                  }

                  &:focus {
                    color: #61cece !important;
                  }
                }

                // &:hover {
                //   opacity: 0.45;
                // }

               
              `}
            >
              <a
                href={`#${id}`}
                onClick={e => {
                  e.preventDefault();

                  const topic = topics.find((t: any) => t.props.name === name);
                  const targetLocation = getTopicSId(topic);

                  if (!targetLocation) {
                    return;
                  }

                  window.locationHistory = getCurrentLocation();
                  //

                  window.location.hash = targetLocation;

                  // setCurrentTopic(id);
                }}
                onKeyUp={e => {
                  // e.preventDefault();
                  if (e.key === ' ') {
                    // setCurrentTopic(id);
                    e.currentTarget.click();
                  }
                }}
                {...(name === currentTopicName
                  ? { 'aria-current': 'page' }
                  : {})}
              >
                {name || id}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Menu;
